import def from "ajv/dist/vocabularies/discriminator"


const Servicos = () => {

    const tecnologias = [
    {
      id: 1,
      titulo: "Aplicações e sistemas de controle",
      descricao: "Desenvolvimento de sistemas backend escaláveis em cloud, front responsivos, ferramentas.",
      aplicacao: "Sistemas corporativos, APIs REST, microserviços e aplicações enterprise.",
      cor: "#1e3c72" // Azul principal do seu site
    },
    {
      id: 2,
      titulo: "AWS - Amazon Web Services",
      descricao: "Infraestrutura cloud completa: computação, armazenamento, bancos de dados e serviços gerenciados.",
      aplicacao: "Migração, deploy, escalabilidade, monitoramento e hospedagem de aplicações.",
      cor: "#FF9900" // Laranja AWS
    },
    {
      id: 3,
      titulo: "Data science",
      descricao: "Modelagem e otimização de bancos relacionais.",
      aplicacao: "Sistemas transacionais, dados estruturados e aplicações corporativas.",
      cor: "#00758F" // Azul SQL
    },
    {
      id: 4,
      titulo: "NoSQL",
      descricao: "Soluções flexíveis para dados semi-estruturados e alto desempenho.",
      aplicacao: "Aplicações modernas, big data, content management e sistemas escaláveis.",
      cor: "#47A248" // Verde MongoDB
    },
    {
      id: 5,
      titulo: "Integração de APIs",
      descricao: "Conectamos seus sistemas com APIs externas e desenvolvemos APIs customizadas.",
      aplicacao: "Integração entre sistemas, terceiros, pagamentos e serviços externos.",
      cor: "#6F42C1" // Roxo
    },
    {
      id: 6,
      titulo: "Desenvolvimento Web",
      descricao: "Interfaces modernas, responsivas e de alta performance.",
      aplicacao: "Aplicações web, dashboards, sistemas administrativos e portais.",
      cor: "#61DAFB" // Azul React
    },
    {
      id: 7,
      titulo: "Desenvolvimento Mobile",
      descricao: "Aplicações mobile nativas para iOS e Android.",
      aplicacao: "Apps corporativos, soluções em campo, vendas e gestão mobile.",
      cor: "#00D8FF" // Azul React Native
    }
  ];

    return(


    <div>
        <div className="modern-jumbotron">
      <div className="jumbotron-content">
        <div className="text-content">
          <p></p>
          <h1 className="jumbotron-title">Nosso trabalho.</h1>
          <p className="jumbotron-lead">Contamos com especialistas de grande experiência, estamos prontos para o desenvolvimento da sua solução.</p>
          <div className="features-grid">
            <div className="feature-item">
              <i className="fas fa-bolt"></i>
              <span>Otimização</span>
            </div>
            <div className="feature-item">
              <i className="fas fa-shield-alt"></i>
              <span>Sustentação</span>
            </div>
            <div className="feature-item">
              <i className="fas fa-robot"></i>
              <span>Automação</span>
            </div>
            <div className="feature-item">
              <i className="fas fa-mobile-alt"></i>
              <span>Mobile</span>
            </div>
          </div>
          
          <p className="jumbotron-subtitle">Logo abaixo você pode checar uma breve descrição de nossos serviços e stack de atuação.</p>
          
          <p className="jumbotron-subtitle"></p>
          
          <div className="cta-container">
            <button className="cta-button-primary">
              <i className="fas fa-chart-line"></i>
              <span>Mais informações</span>
            </button>
          </div>
        </div>
        
        <div className="visual-content">
          <div className="tech-illustration">
            <div className="code-window">
              <div className="window-header">
                <div className="window-dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
              <div className="code-content">
                <div className="code-line"></div>
                <div className="code-line short"></div>
                <div className="code-line"></div>
                <div className="code-line short"></div>
                <div className="code-line"></div>
              </div>
            </div>
            <div className="floating-shape shape-1"></div>
            <div className="floating-shape shape-2"></div>
            <div className="floating-shape shape-3"></div>
          </div>
        </div>
      </div>
      
    </div>

        <div className="container mt-4">
      {/* Header da Página */}
      <div className="text-center mb-5">
        <h1 className="display-5 fw-bold" style={{ color: '#1e3c72' }}>
          
        </h1>
        <p className="lead">
          
        </p>
      </div>

      {/* Grid de Cards */}
      <div className="row g-4 mb-5">  {/* Adicionei mb-5 para margem inferior */}
  {tecnologias.map(tech => (
    <div key={tech.id} className="col-lg-4 col-md-6 mb-2">  {/* Adicionei mb-4 */}
      <div 
        className="card h-100 border-0 shadow-sm"
        style={{ 
          borderLeft: `4px solid ${tech.cor}`,
          transition: 'transform 0.2s',
          marginBottom: '1.5rem'  /* Espaçamento extra garantido */
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-5px)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
        }}
      >
        <div className="card-body p-4">  {/* Aumentei o padding interno */}
          {/* Conteúdo do card permanece igual */}
          <h5 
            className="card-title fw-bold"
            style={{ color: tech.cor, fontWeight: 'bold' }}
          >
            {tech.titulo}
          </h5>
          
          <p className="card-text text-muted mb-3">
            {tech.descricao}
          </p>
          
          <div className="mt-auto">
            <small className="text-muted fw-semibold">Aplicação:</small>
            <p className="card-text small" style={{ color: '#495057' }}>
              {tech.aplicacao}
            </p>
          </div>
        </div>
      </div>
    </div>
  ))}
</div>     
    </div>
       
    </div>
    );
}

export default Servicos;